import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { IUser, User, IUserRoleRights } from './login';
import { UserService } from '../services/user.service';
import { ToastrService} from 'ngx-toastr';
import { AppSettings } from '../../app.settings';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    providers: [UserService, ToastrService],
    encapsulation: ViewEncapsulation.None
})
export class LoginComponent {
    public router: Router;
    public form: FormGroup;
    public name: AbstractControl;
    public password: AbstractControl;
    public captcha : AbstractControl;
    public user: IUser;
    private notificationTitle: string = '';
    private errorMessage: string;
    public loading = false;
    public recaptchaKey: string;
   
    constructor(router: Router, fb: FormBuilder, private _userService: UserService, private toastr: ToastrService ) {
        this.router = router;
        this.form = fb.group({
            'name': ['', Validators.compose([Validators.required])],
            'password': ['', Validators.compose([Validators.required, Validators.minLength(4)])],
            'captcha' : ['' , Validators.compose([Validators.required])]
        });

        this.name = this.form.controls['name'];
        this.password = this.form.controls['password'];
        this.captcha = this.form.controls['captcha'];
        this.recaptchaKey = `${AppSettings._RecaptchaKey}`;
    }

   
    public onSubmit(values: Object): void {
        if (this.form.valid) {
            this.loading = true;
            let user: User = new User(0,"" ,this.form.value.name, this.form.value.password, '', '', true, 0, '', 1,'','',new Date(),0);
            this._userService.getLoginUser(user).subscribe(
                
                data => {
                    if (data != null) {
                        this.user = data;
                        this.loading = false;
                        localStorage.setItem('currentUser', JSON.stringify(this.user));
                        this.router.navigate(['pages/schedule']);
                    }
                    else {
                        this.loading = false;
                        this.notificationTitle = 'Invalid Login Attempt.';
                        this.toastr.error(this.notificationTitle);
                    }
                },
                error => {
                    this.loading = false;
                    this.errorMessage = <any>error;
                    this.notificationTitle = this.errorMessage;
                    this.toastr.error(this.notificationTitle);
                },
                () => {
                    this.loading = false;
                    this.notificationTitle = 'Logged In successfully.';
                    this.toastr.success(this.notificationTitle);                    
                }
            );
            
        }
    }

    ngAfterViewInit() {
        document.getElementById('preloader').classList.add('hide');
    }

}

export function emailValidator(control: FormControl): { [key: string]: any } {
    var emailRegexp = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/;
    if (control.value && !emailRegexp.test(control.value)) {
        return { invalidEmail: true };
    }
}



// WEBPACK FOOTER //
// E:/sachin/Project/Masterly_Solutions/Project_HRMS/Hrms_Developer/hrms/Peerless.HRMS.WebUI.EmployeePortal/src/app/pages/login/login.component.ts